import { undoIcon } from "../elements/icons/index.js";
import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * Stack editor.
 *
 * It displays a list of items as "tags".
 *
 * Editing methods operate on the list as a stack: items in the list are
 * added and removed from the back.
 * - push: Append an item to the list.
 * - pop: Remove the last item of the list.
 *
 * @param {object[]} [spec.items=[]] - List of items. Each item is an
 * object with at least a `label` property. An item may also have a
 * `cssClass` property that is added to the corresponding tag.
 */
export default class StackEditorWidget extends Widget {
	constructor({ items = [] } = {}) {
		super(...arguments);
		this._items = items.slice();
		this.popped = this._events.createEvent();
	}

	getItems() {
		return this._items.slice();
	}

	setItems(items) {
		this._items = items.slice();
		this.update();
	}

	push(item) {
		this._items.push(item);
		this.update();
	}

	pop() {
		const item = this._items.pop();
		this.popped.trigger(item);
		this.update();
	}

	renderContentOn(html) {
		html.div(
			{ klass: "list-editor", "data-test": "formula-list-editor" },
			this._renderItemsOn.bind(this),
		);
	}

	_renderItemsOn(html) {
		html.ul(
			{ klass: "items" },
			this._items.map(this._itemRenderer),
			this._renderRemoveLastItemOn.bind(this),
		);
	}

	_itemRenderer(item) {
		return (html) => {
			html.li({ klass: item.cssClass || "" }, item.label);
		};
	}

	_renderRemoveLastItemOn(html) {
		html.li({ klass: "remove" }, undoIcon).click(() => this.pop());
	}
}
